/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MoveTeamsNotificationSettingForCardRequest
 */
export interface MoveTeamsNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof MoveTeamsNotificationSettingForCardRequest
     */
    'channelId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveTeamsNotificationSettingForCardRequest
     */
    'transactionTypes': Array<MoveTeamsNotificationSettingForCardRequestTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof MoveTeamsNotificationSettingForCardRequest
     */
    'largeAmountThreshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveTeamsNotificationSettingForCardRequest
     */
    'userAccountIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveTeamsNotificationSettingForCardRequest
     */
    'groupIds': Array<string>;
}

export const MoveTeamsNotificationSettingForCardRequestTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type MoveTeamsNotificationSettingForCardRequestTransactionTypesEnum = typeof MoveTeamsNotificationSettingForCardRequestTransactionTypesEnum[keyof typeof MoveTeamsNotificationSettingForCardRequestTransactionTypesEnum];


